import customerData from 'images/product/customer-data.svg';
import adChannels from 'images/product/ad-channels.svg';
import newCampaignsGraphic from 'images/product/new-campaigns-graphic.svg';
import warehouseGraphic from 'images/product/warehouse-graphic.svg';


export default {
  header: {
    desc: 'Iterio automatically captures customer data and uses it to find new customers.  Then makes it easy to '
    + 'measure your funnel and improve conversion rates.',
  },
  steps: [{
    icon: customerData,
    title: 'Connect your customer data',
    preTitle: 'Step 1',
    desc: 'Iterio automatically captures customer data from your Intercom CRM, website visitors, and app database. Just connect one of these data sources to start finding new customers.',
  }, {
    icon: adChannels,
    title: 'Connect an advertising channel',
    preTitle: 'Step 2',
    desc: 'Iterio combines your customer data sources to create target audiences for new campaigns. When you connect an advertising account we send your data there and keep it in sync.',
  }, {
    icon: newCampaignsGraphic,
    title: 'Launch new campaigns',
    preTitle: 'Step 3',
    desc: 'Iterio builds audiences likely to convert to new customers. This allows you to quickly launch new campaigns across multiple channels.',
  }, {
    icon: warehouseGraphic,
    title: 'Get your own customer data warehouse',
    preTitle: 'Next level',
    desc: 'Data warehouses centralize customer data so you can measure your marketing funnel.  Iterio can create and manage a data warehouse containing all your customer data.  Or deliver this data to your existing data warehouse.',
    modifier: 'next-lvl',
  }],
};



// WEBPACK FOOTER //
// ./src/config/landing.js